/**
 * Typed worker wrapper for distance computation.
 *
 * `ComlinkWorker` is a global injected by vite-plugin-comlink at build time.
 * This module provides typed helper functions so consumers don't need to know
 * the internal worker file path or the ComlinkWorker API.
 *
 * NOTE: These functions must only be called inside Vite-bundled code (apps).
 * They rely on `import.meta.url` and the `ComlinkWorker` global.
 */

export type DistanceWorkerType = typeof import('../utils/worker');

// eslint-disable-next-line @typescript-eslint/no-explicit-any
let _cached: any = null;

/**
 * Returns a cached Comlink-wrapped Web Worker for distance computation.
 */
export function getDistanceWorker(): DistanceWorkerType {
  if (!_cached) {
    // @ts-expect-error ComlinkWorker is a vite-plugin-comlink global
    _cached = new ComlinkWorker<DistanceWorkerType>(
      new URL('../utils/worker', import.meta.url),
      { type: 'module' },
    );
  }
  return _cached as DistanceWorkerType;
}

/**
 * Creates a fresh worker instance (useful for isolation/parallel dispatches).
 */
export function createDistanceWorker(): DistanceWorkerType {
  // @ts-expect-error ComlinkWorker is a vite-plugin-comlink global
  return new ComlinkWorker<DistanceWorkerType>(
    new URL('../utils/worker', import.meta.url),
    { type: 'module' },
  );
}

